(function () {
  "use strict";

  var DAY_KEYS = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  function markTodayRows(root) {
    var todayKey = DAY_KEYS[new Date().getDay()];

    root.querySelectorAll("[data-fw-store-day]").forEach(function (row) {
      var key = row.getAttribute("data-fw-store-day");
      var isToday = key === todayKey;
      row.classList.toggle("is-today", isToday);
      row.classList.remove("is-tomorrow");
      var todayBadge = row.querySelector("[data-fw-store-today-badge]");
      var tomorrowBadge = row.querySelector("[data-fw-store-tomorrow-badge]");
      if (todayBadge) todayBadge.hidden = !isToday;
      if (tomorrowBadge) tomorrowBadge.hidden = true;
    });
  }

  function initStoreHours(root) {
    if (!root || root.dataset.fwStoreHoursInit === "true") return;
    root.dataset.fwStoreHoursInit = "true";
    markTodayRows(root);
  }

  function boot() {
    document.querySelectorAll(".fw-store-hours").forEach(initStoreHours);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target;
    if (!(section instanceof Element)) return;
    section.querySelectorAll(".fw-store-hours").forEach(function (el) {
      el.dataset.fwStoreHoursInit = "";
      initStoreHours(el);
    });
  });
})();
